import { Component, OnDestroy, OnInit } from '@angular/core';

import { Maintenance } from '@app/models/_index';
import { MaintenanceAdapter } from '@app/adapters/maintenance.adapter';
import { MaintenanceInterface } from '@app/interfaces/_index';
import { NotificationService } from '@app/services/wordpress/notification.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-maintenance-downtime',
  templateUrl: './maintenance-downtime.component.html',
  styleUrls: ['./maintenance-downtime.component.scss'],
  standalone: false,
})
export class MaintenanceDowntimeComponent implements OnInit, OnDestroy {
  sub: Subscription;
  maintenance: Maintenance;

  constructor(
    private notificationService: NotificationService,
    private maintenanceAdapter: MaintenanceAdapter,
    private router: Router
  ) {}

  /**
   * Oninit load Maintenance Downtime
   * Subscribe to the notification service to check if the maintenance is enabled or disabled.
   */
  ngOnInit(): void {
    this.sub = this.notificationService
      .getMaintenance()
      .subscribe((maintenance: MaintenanceInterface) => {
        if (maintenance) {
          this.maintenance = this.maintenanceAdapter.adapt(maintenance[1]);
          if (this.maintenance && this.maintenance.enable_downtime === false) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  /**
   * OnDestroy unsubscribe the maintenance notifciation service
   */
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
